import React from "react";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Button as MUIButton,
  Typography,
  Box,
  Button,
  Grid,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import SectionTitle from "./SectionTitle";
import SectionText from "./SectionText";
import Animate from "./Animate";
import HeroAnimation from "../../../assets/animations/hero-animation.json";

const useStyles = makeStyles((theme) => ({
  dialogContent: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: theme.spacing(4),
    backgroundColor: "#F5F7FA",
    [theme.breakpoints.down("sm")]: {
      flexDirection: "column",
    },
  },
  textContainer: {
    textAlign: "center",
    [theme.breakpoints.up("md")]: {
      textAlign: "left",
    },
  },
  titleText: {
    fontSize: "2.5rem",
    lineHeight: "1.2",
    fontWeight: "bold",
    color: "#000",
    "& span": {
      color: "#007BFF",
    },
    [theme.breakpoints.down("sm")]: {
      fontSize: "2.5rem",
    },
  },
  sectionText: {
    fontSize: "1rem",
    lineHeight: "1.5",
    color: "#555",
    marginTop: theme.spacing(2),
  },
  poweredBy: {
    display: "flex",
    alignItems: "center",
    marginTop: theme.spacing(2),
  },
  poweredByText: {
    marginRight: theme.spacing(1),
    fontSize: "0.75rem",
  },
  button: {
    backgroundColor: "#007BFF",
    color: "#fff",
    padding: theme.spacing(2, 4),
    borderRadius: "50px",
    fontSize: "1rem",
    "&:hover": {
      backgroundColor: "#fff",
      color: "#007BFF",
      border: "1px solid #007BFF",
    },
  },
  buttonCancel: {
    backgroundColor: "#fff",
    color: "#007BFF",
    padding: theme.spacing(2, 4),
    borderRadius: "50px",
    border: "1px solid #007BFF",
    fontSize: "1rem",
    "&:hover": {
      backgroundColor: "#007BFF",
      color: "#fff",
    },
  },
  animationContainer: {
    marginTop: theme.spacing(4),
    [theme.breakpoints.down("sm")]: {
      display: "none",
    },
  },
  action: {
    border: "none",
  }
}));

type BannerProps = {
  open: boolean;
  onClose: () => void;
  onButtonClick: () => void;
};

export default function Banner({ open, onClose, onButtonClick }: BannerProps) {
  const classes = useStyles();

  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <DialogContent dividers className={classes.dialogContent}>
        <Box className={classes.textContainer}>
          <SectionTitle className={classes.titleText}>
            Start <br/>
            <span>Winning Today</span>
            <br />
            With <br/>
            <span>Ledgity</span> Staking
          </SectionTitle>
          <SectionText className={classes.sectionText}>
            Participants earn rewards for holding coins, with guaranteed time-based returns. The longer you stake, the more you earn.
          </SectionText>
          <Grid container direction="row" spacing={2} justifyContent="center" style={{ marginTop: 10 }}>
            <Grid item xs={12} sm={6}>
              <Button className={classes.button} onClick={onButtonClick} fullWidth>
                Stake Now
              </Button>
            </Grid>
            <Grid item xs={12} sm={6}>
              <Button className={classes.buttonCancel} onClick={onClose} fullWidth>
                Remind Me Later
              </Button>
            </Grid>
          </Grid>
        </Box>
        <Box className={classes.animationContainer}>
          <Animate animationData={HeroAnimation} />
        </Box>
      </DialogContent>
    </Dialog>
  );
}